export const REFRESH_SEARCH_PROFILE = 'REFRESH_SEARCH_PROFILE'
export const GET_SEARCH_PROFILE = 'GET_SEARCH_PROFILE'
export const SET_SEARCH_PROFILE = 'SET_SEARCH_PROFILE'
export const SET_SORT_PROFILE = 'SET_SORT_PROFILE'
